import React, { useRef, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import EditEcole from './EditEcole';
import Bunexe_service from '../../Bunexe_service';

const InfoEcole = ({
  ecole_selectionne,
  setTexte_Recherche,
  setEcole_selection,
  cheminpush,
  info_={info_}
}) => {
  const histo = useHistory();
  const mybuttonref = useRef(null);
  const [loaded, setLoaded] = useState(false);
  let monEcole;
  const activer_ecoleSelectionne = () => {
    setEcole_selection(ecole_selectionne);
    // histo.push('/neuvieme/9af');
   // console.log(cheminpush);
    histo.push(cheminpush);
  };
  useEffect(() => {
    setEcole_selection(ecole_selectionne);
    Bunexe_service.ecole_selection = { ...ecole_selectionne };
    // monEcole = ecole_selectionne;
    setLoaded(true);
    // alert(`${JSON.stringify(Bunexe_service.ecole_selection)}`);
  }, [ecole_selectionne]);
  return (
    ecole_selectionne && (
      <div className='mt-4 border rounded p-4'>
        <h3 className='text-center display 4'>{ecole_selectionne.LibelleEt}</h3>
        <hr />
        <p>
          <span className='font-weight-bold'>Code :</span>
          <span className='font-italic font-weight-light'>
            {ecole_selectionne.Ecole}
          </span>
        </p>
        <p>
          <span className='font-weight-bold'>Adresse :</span>
          <span className='font-italic font-weight-light'>
            {ecole_selectionne.AdresseEt}
          </span>
        </p>
        <p>
          <span className='font-weight-bold'>Directeur :</span>
          <span className='font-italic font-weight-light'>
            {ecole_selectionne.Directeur}
          </span>
        </p>
        <p>
          <span className='font-weight-bold'>District :</span>
          <span className='font-italic font-weight-light'>
            {ecole_selectionne.District}
          </span>
        </p>
        <p>
          <span className='font-weight-bold'>Zone :</span>
          <span className='font-italic font-weight-light'>
            {ecole_selectionne.Zone}
          </span>
        </p>
        <p>
          <span className='font-weight-bold'>Siege :</span>
          <span className='font-italic font-weight-light'>
            {ecole_selectionne.CodeSiege}
          </span>
        </p>
        <p className='d-flex justify-content-between my-2'>
          {/* <button
            className='btn btn-primary btn-small'
            onClick={(e) =>
              alert(
                `Patientez!!!, DAEPP est entrain de devellopper cette fonctionnalité`
              )
            }
          >
            renouveler accreditation
          </button> */}
          {}

          <EditEcole
            setTexte_Recherche={setTexte_Recherche}
            ecole_selectionne={ecole_selectionne}
            setEcole_selectionne={setEcole_selection}
            info_={info_}
          />
          <button
            className='btn btn-primary btn-small'
            onClick={activer_ecoleSelectionne}
          >
            Selectionner
          </button>
        </p>
      </div>
    )
  );
};

export default InfoEcole;
